import { useTranslation } from "react-i18next";

/**
 * Banner sotto topbar quando l'integrazione è in standby/chiusa o disattiva:
 * messaggio diverso se trial (scaduto o in standby) vs abbonamento.
 */
export default function BillingAttentionBanner({ shop, onGoSubscription }) {
  const { t } = useTranslation("common");
  if (shop?.is_agency_managed) return null;
  const inactive =
    shop?.commercial_state === "standby" ||
    shop?.commercial_state === "closed" ||
    shop?.integration_active === false;
  if (!inactive) return null;
  const trialExpired =
    shop?.plan === "trial" && shop?.trial_expires_at && new Date(shop.trial_expires_at) < new Date();
  const trialStandby = shop?.plan === "trial" && shop?.commercial_state === "standby";
  const useTrialMsg = trialExpired || trialStandby;
  const text = useTrialMsg ? t("banner.billing.trialBody") : t("banner.billing.subscriptionBody");
  return (
    <div
      className="ch-app-banner ch-app-banner--billing"
      role="status"
      style={{
        background: "#fff8f0",
        borderBottom: "1px solid #ffe0b2",
        padding: "12px 24px",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 10,
        fontSize: 14,
      }}
    >
      <span style={{ fontWeight: 600, color: "#b45309" }}>{text}</span>
      <button type="button" className="ch-btn ch-btn-primary ch-btn-sm" style={{ padding: "6px 14px" }} onClick={onGoSubscription}>
        {t("pill.choosePlan")}
      </button>
    </div>
  );
}
